// extracted by mini-css-extract-plugin
export default {"presentRichText":"IiDaymagM08dOiDR8IDh"};